import { render, staticRenderFns } from "./MenuCreateEditModal.vue?vue&type=template&id=79fbfcfe&scoped=true&"
import script from "./MenuCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./MenuCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuCreateEditModal.vue?vue&type=style&index=0&id=79fbfcfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fbfcfe",
  null
  
)

/* custom blocks */
import block0 from "./MenuCreateEditModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VDialog,VFileInput,VForm,VSelect,VSheet,VTextField})
